import { BUBBLE, COMMON, ifyouApi } from 'apis/config';
import ErrorMessage from 'apis/ErrorMessage';

// *** 말풍선 이미지

export const bubbleSpriteApi = {
  read: () =>
    ifyouApi
      .get(`${BUBBLE}/bubble-sprite-select`, {
        func: 'getPlatformBubbleSprite',
        code: '',
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  register: (formData) =>
    ifyouApi
      .post(`${BUBBLE}/bubble-sprite-insert`, formData, {
        header: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  update: (formData) =>
    ifyouApi
      .post(`${BUBBLE}/bubble-sprite-update`, formData, {
        header: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  delete: (bubbleSpriteId) =>
    ifyouApi
      .post(`${BUBBLE}/bubble-sprite-delete`, {
        bubble_sprite_id: bubbleSpriteId,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  fetchTemplateList: () =>
    ifyouApi
      .post(`${COMMON}`, {
        func: 'standard',
        code: 'talking_template',
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
};
